import { render, staticRenderFns } from "./OffDates.vue?vue&type=template&id=e4197f76&scoped=true&"
import script from "./OffDates.vue?vue&type=script&lang=js&"
export * from "./OffDates.vue?vue&type=script&lang=js&"
import style0 from "./OffDates.vue?vue&type=style&index=0&id=e4197f76&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e4197f76",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCardActions } from 'vuetify/lib/components/VCard';
import { VSpacer } from 'vuetify/lib/components/VGrid';
installComponents(component, {VBtn,VCardActions,VSpacer})
